import { handleAPI, API_VERSION_TWO } from 'utils/apiUtils'
import { Action } from 'types/redux'

export function employeeLeavesLoad(employee_id: number): Action {
  const url = `/${API_VERSION_TWO}/employees/${employee_id}/leaves/summary`
  const method = 'GET'

  return {
    type: 'EMPLOYEE_LEAVES_LOAD',
    payload: handleAPI(url, {}, method),
  }
}

export function employeeLeavesHistoryLoad(
  employee_id: number,
  params: Record<string, unknown> = {},
): Action {
  const url = `/${API_VERSION_TWO}/employees/${employee_id}/leaves/history`
  const method = 'GET'

  return {
    type: 'EMPLOYEE_LEAVES_HISTORY_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function employeeLeaveDelete(employee_id: number, leave_id: number): Action {
  const url = `/${API_VERSION_TWO}/employees/${employee_id}/leave_requests/${leave_id}`
  return {
    type: 'EMPLOYEE_LEAVE_DELETE',
    payload: {
      promise: handleAPI(url, {}, 'DELETE'),
      data: { leave_id },
    },
  }
}

export function employeeLeaveTypesLoad(
  employee_id: number,
  params: Record<string, unknown> = {},
): Action {
  const url = `/${API_VERSION_TWO}/employees/${employee_id}/leave_types`
  const method = 'GET'

  return {
    type: 'EMPLOYEE_LEAVES_HISTORY_TYPES_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function employeeYearsLoad(
  employee_id: number,
  params: Record<string, unknown> = {},
): Action {
  const url = `/${API_VERSION_TWO}/employees/${employee_id}/employee_years`
  const method = 'GET'

  return {
    type: 'EMPLOYEE_YEARS_LOAD',
    payload: handleAPI(url, params, method),
  }
}
